import { lazy } from 'react';
import { Crown } from 'lucide-react';
import type { FeatureSection } from '@/app/registry';

/** Plans & marketing: memberships and ride passes (plans, templates, holders), Veo Connect, Veo Promo and experiments. */
export const plansSection: FeatureSection = {
  key: 'plans',
  title: 'plansMarketing',
  icon: Crown,
  routes: [
    {
      path: '/plans/memberships',
      title: 'memberships',
      tabs: [
        { key: 'plans', title: 'marketPlans', resource: 'membership', component: lazy(() => import('./memberships/AreaMembershipsPage')) },
        { key: 'members', title: 'members', resource: 'customer', legacyPath: '/customers/memberships', component: lazy(() => import('@/features/customers/memberships/CustomerMembershipsPage')) },
        { key: 'templates', title: 'templates', resource: 'membership', legacyPath: '/plans/membership-templates', component: lazy(() => import('./memberships/TemplatesPage')) },
        { key: 'enterprise', title: 'enterprise', resource: 'membership', legacyPath: '/plans/enterprise', component: lazy(() => import('./memberships/EnterprisePage')) },
      ],
    },
    {
      path: '/plans/passes',
      title: 'ridePasses',
      tabs: [
        { key: 'plans', title: 'marketPasses', resource: 'pass', component: lazy(() => import('./passes/AreaPassesPage')) },
        {
          key: 'holders',
          title: 'passHolders',
          resource: 'customer',
          legacyPath: '/customers/passes',
          component: lazy(() => import('@/features/customers/passes/PassManagementPage').then((m) => ({ default: m.PassHolders }))),
        },
        {
          key: 'purchases',
          title: 'purchases',
          resource: 'customer',
          component: lazy(() => import('@/features/customers/passes/PassManagementPage').then((m) => ({ default: m.PassPurchases }))),
        },
        { key: 'templates', title: 'templates', resource: 'pass', legacyPath: '/plans/pass-templates', component: lazy(() => import('./passes/PassTemplatesPage')) },
      ],
    },
    { path: '/plans/events', title: 'destinationEvents', resource: 'destination-event', component: lazy(() => import('./events/EventsPage')) },
    { path: '/plans/connect', title: 'veoConnect', resource: 'connect', component: lazy(() => import('./connect/ConnectPage')) },
    // the gateway guards area-promo-campaign with promo:*, not connect:*
    { path: '/plans/promo-codes', title: 'promoCodes', resource: 'promo', marketIndependent: true, component: lazy(() => import('./promo-codes/PromoCodesPage')) },
    { path: '/plans/promo', title: 'veoPromo', resource: 'connect', component: lazy(() => import('./promo/PromoPage')) },
    { path: '/plans/experiments', title: 'experiments', tabs: [
      { key: 'membership', title: 'memberships', resource: 'membership', component: lazy(() => import('./experiments/MembershipExperimentsPage')) },
      { key: 'pass', title: 'ridePasses', resource: 'pass', component: lazy(() => import('./experiments/PassExperimentsPage')) },
    ] },
  ],
};
